import { injectGlobal } from 'styled-components';


/* eslint no-unused-expressions: 0 */
injectGlobal`
  @import url('//use.typekit.net/jko1btw.css');

  *{
    font-family: franklin-gothic-urw, Helvetica, Arial, sans-serif;
  }

  h1, h2, h3, h4{
    font-family: franklin-gothic-urw, Helvetica, Arial, sans-serif !important;
    font-weight: bold;
    margin: 0 0 20px 0;
  }

  p{
    margin: 0 0 10px 0 !important;
  }

  input, select{
    width: 100%;
    height: 45px;
    border: 1px solid #AAA;
    margin-bottom: 20px;
    padding: 0 10px;
    background-color: #ffffff;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    &:focus{
      border: 1px solid #5E00E6;
      box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px #5E00E6;
      outline: none;
    }
  }

  label{
    width:100%;
    margin-bottom: 10px;
  }

  .toolbar > *{
    display: inline-block;
  }
`;



// WEBPACK FOOTER //
// ./app/global-styles.js